import { event } from "@foretagsplatsen/yaem";
import Model from "../../../Model.js";

/**
 * Abstract section of a period report. A period report is composed of a list of
 * sections, each section being displayed (as a document section) when rendering
 * the report.
 *
 * @abstract
 * @param {periodReport} spec.periodReport - The period report the section belongs to.
 * @param {string} [spec.comment] - The comment is an HTML string associated to this
 * specific section, to be displayed next to the content of the section.
 * @param {boolean} [spec.enabled=true] - Whether the section should be displayed.
 */
export default class AbstractPeriodReportSection extends Model {
	constructor({ periodReport, comment = "", enabled = true } = {}) {
		super(...arguments);
		this._periodReport = periodReport;
		this._comment = comment;
		this._enabled = enabled;

		this.changed = event();
		this.commentChanged = event();
	}

	getId() {
		return this.constructor.getId();
	}

	getTitle() {
		return this._subclassResponsibility();
	}

	getIcon() {
		return this.getId();
	}

	getPeriodReport() {
		return this._periodReport;
	}

	setPeriodReport(periodReport) {
		this._periodReport = periodReport;
	}

	canHaveReport() {
		return false;
	}

	getComment() {
		return this._comment;
	}

	setComment(comment) {
		this._comment = comment;
		this.commentChanged.trigger(this);
	}

	appendComment(comment = "") {
		this.setComment(this._comment + comment);
	}

	toggle() {
		this._enabled = !this._enabled;
	}

	setEnabled(enabled) {
		this._enabled = enabled;
	}

	isEnabled() {
		return this._enabled;
	}

	hasComment() {
		return this._comment.length > 0;
	}

	canBeCommented() {
		return true;
	}

	accept(_visitor) {
		return this.subclassResponsibility();
	}

	_serializedProperties() {
		const data = super._serializedProperties();

		data.type = this.constructor.getType();
		data.id = this._id;
		data.comment = this._comment;
		data.enabled = this._enabled;

		return data;
	}

	static getType() {
		return "";
	}

	static getId() {
		return "";
	}

	static isAgedAccountsSection() {
		return false;
	}
}
